import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Directions,
  spotConstants,
  translationConstants,
} from "../../../../constants";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SpotActions } from "../../../../redux/actions";
import SpotDetails from "./Tabs/SpotDetails";
import FreelanceInstructors from "./Tabs/FreelanceInstructors";
import SpotCenters from "./Tabs/Centers";
import { googleLocationUrl, moveBack } from "../../../../system";
import { ArrowLeftIcon, DirectionIcon } from "../../../../assets/images/icon";

function SpotDetail() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const spotDetail = useSelector((state) => state?.SpotsReducer?.spotDataById);
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  useEffect(() => {
    dispatch(SpotActions.getSpotById(state?.centerId));
  }, []);
  
  return (
    <div className="container">
      <section id="spot-detail-main-container" className="mx-4">
        <section className="pt-3">
          <div className="row">
            <div className="col-12">
              <div className="d-flex gap-3">
                <div className="d-flex align-items-center">
                  <span
                    className="cursor-pointer rotated-element"
                    onClick={moveBack}
                  >
                    <img src={ArrowLeftIcon} />
                  </span>
                </div>
                <div className="d-flex align-items-center">
                  <label className="fw-bold font-30 pt-0">
                    {direction == Directions.rtl &&
                    spotDetail?.spotInfo?.arabicName
                      ? spotDetail?.spotInfo?.arabicName
                      : spotDetail?.spotInfo?.name}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div>
              <span className="font-20 pb-3">
                (
                {spotDetail?.spotInfo?.spotTypeId ==
                spotConstants.spotType.PUBLIC
                  ? t(translationConstants.PUBLIC)
                  : t(translationConstants.PRIVATE)}
                )
              </span>
            </div>
            <div className="d-block d-md-none">
              <a
                href={googleLocationUrl(
                  spotDetail.spotInfo?.lat,
                  spotDetail.spotInfo?.long
                )}
                target="_blank"
                className="font-14 center-card-view-detail-link "
              >
                <img src={DirectionIcon} alt="get directions icon" />
                {t(translationConstants.GET_DIRECTIONS)}
              </a>
            </div>
          </div>
        </section>
        <section id="spot-detail-tabs">
          <div className="col-md-12 view-center-profile-scroll-tabs">
            <Tabs>
              {/* Center Tab Links */}
              <TabList>
                <Tab>{t(translationConstants.SPOT_DETAILS)}</Tab>
                {spotDetail?.spotInfo?.spotTypeId ==
                  spotConstants.spotType.PUBLIC && (
                  <Tab>{t(translationConstants.FREELANCE_INSTRUCTOR)}</Tab>
                )}
                <Tab>{t(translationConstants.CENTERS)}</Tab>
              </TabList>
              {/* Center General Tab */}
              <TabPanel>
                <SpotDetails spotDetail={spotDetail} />
              </TabPanel>
              {/* Center Location Tab */}
              {spotDetail?.spotInfo?.spotTypeId ==
                  spotConstants.spotType.PUBLIC && <TabPanel>
                <FreelanceInstructors spotId={spotDetail.id} />
              </TabPanel>}
              {/* Center Instructor Tab */}
              <TabPanel>
                <SpotCenters spotId={spotDetail.id} spotDetail={spotDetail} />
              </TabPanel>
            </Tabs>
          </div>
        </section>
      </section>
    </div>
  );
}

export default SpotDetail;
